import {
  TENANT_PAYOUT_BANK_DOC_ID,
  TenantPayoutBankDocSchema,
  type TenantPayoutBankDoc,
} from '@kilat/shared';

import { createRepo } from './_base.js';

/**
 * Payout destination — `tenants/{tid}/private/payoutBank`.
 *
 * Bank account number, account holder name and DuitNow ID (often an NRIC).
 * It used to be a field on the tenant root, which `firestore.rules` makes
 * world-readable so the customer PWA can boot; see
 * `TenantPayoutBankAccountSchema` in `@kilat/shared` for the full account.
 *
 * READ ONLY from the client. Owner/manager (and the tenant's brand
 * super-admin) may read it; nobody may write it from a client. The owner
 * saves through the `setPayoutBankAccount` callable
 * (`lib/callables/billing.ts`), which is owner-only — a manager who could
 * repoint payouts could pay the business's money to themselves.
 *
 * The collection segment is spelled LITERALLY for the same reason as
 * `tenant-tax-repo.ts` (seed:coverage resolves `path:` strings);
 * `tenant-payout-bank-repo.test.ts` pins it to the shared constant.
 */
export type { TenantPayoutBankDoc };

export { TENANT_PAYOUT_BANK_DOC_ID };

export function tenantPayoutBankRepoFor(tenantId: string) {
  return createRepo({
    path: `tenants/${tenantId}/private`,
    schema: TenantPayoutBankDocSchema,
    name: `tenants/${tenantId}/private/payoutBank`,
  });
}
